import Apartment from '@/services/api/apartment.js';

export default {
  namespaced: true,
  actions: {
    connectEvoApi (state) {
      return new Promise((resolve, reject) => {
        Apartment.connectEvoApi()
          .then(({ data }) => {
            resolve(data);
          })
          .catch(error => reject(error));
      });
    },
    billingInfo (state, apartmentId) {
      return new Promise((resolve, reject) => {
        Apartment.billingInfo(apartmentId)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(error => reject(error));
      });
    },
    getSipSettings (state, { login, reason }) {
      return new Promise((resolve, reject) => {
        Apartment.getSipSettings({ login, reason })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(error => reject(error));
      });
    },
    editPaid (state, { apartmentSipSettingsId, paid }) {
      return new Promise((resolve, reject) => {
        Apartment.editPaid(apartmentSipSettingsId, paid)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    apartmentPayment (state, { doorphoneId, paid, apartment }) {
      return new Promise((resolve, reject) => {
        Apartment.apartmentPayment(doorphoneId, paid, apartment)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    createBillingAccount (state, phone) {
      return new Promise((resolve, reject) => {
        Apartment.createBillingAccount(phone)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
  },
};
